<!-- Dashboard.tsx: feed header + PostComposer + <div>{posts}</div> -->
<app-lovable-feed-header [activeTab]="activeTab" (activeTabChange)="activeTabChange.emit($event)"></app-lovable-feed-header>
<app-lovable-post-composer></app-lovable-post-composer>
<div>
  <app-lovable-post-card *ngFor="let post of posts" [post]="post"></app-lovable-post-card>
</div>
